import { rankWith, uiTypeIs } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { FormItem } from '../../../../../controls/FormItem';
import { FieldProps, WithDynamicFormContext } from '../WithDynamicFormContext';

import './style.scss';
import { get } from 'lodash';
import { AntDatepicker } from '../../../../../controls/AntDatePicker';
import moment from 'moment';

const DurationDatePicker = ({
  path,
  label,
  data,
  handleChange,
  handleBlur,
  handleRemove,
  required,
  schema,
  uischema,
  formData,
  disabled,
  optionalMessage,
}: FieldProps) => {
  const handleUpdate = (_: any, date: string) => {
    const durationPath = uischema.options?.dependencies[0];
    const durationValue =
      get(formData, uischema.options?.dependencies[1]) |
      uischema.options?.dependencies[2];

    if (!!date) {
      handleChange(path, date);
      handleChange(
        durationPath,
        moment(date).add(durationValue, 'M').format('YYYY-MM-DD'),
      );
    } else handleRemove(path);
  };
  const moreInfo = uischema.options?.moreInfo;
  const minDate = uischema.options?.minDate;
  const maxDate = uischema.options?.maxDate;

  return (
    <FormItem
      label={label as string}
      required={required}
      classes="tru-datepicker-input-control"
      moreInfo={moreInfo}
      optionalMessage={optionalMessage}
    >
      <AntDatepicker
        value={data}
        onBlur={() => handleBlur(path)}
        onChange={handleUpdate}
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
      />

      {schema.description && (
        <p className="description margin-bottom">{schema.description}</p>
      )}
    </FormItem>
  );
};

export const DatePickerWithDuration = {
  tester: rankWith(100, uiTypeIs('DurationDatePicker')),
  renderer: withJsonFormsControlProps(
    WithDynamicFormContext(DurationDatePicker),
  ),
};
